export default __webpack_public_path__ + "static/media/trial-card-gradient.52eb876e.png";